<template>
<div>
  <el-dialog
    :title="title"
    :close-on-click-modal="false"
     v-dialogDrag
     @close="closeDialog"
    :visible.sync="visible">
    <el-button v-if="method != 'add'" size="medium" class="mb8" icon="el-icon-edit" type="warning"  @click="handEditorView(method)" :disabled="!hasPermission('unmspace:cecUnmProject:edit')">编辑</el-button>
    <el-form :model="inputForm" size="small" ref="inputForm" v-loading="loading" :class="method==='view'?'readonly':''"  :disabled="method==='view'"
             label-width="120px">
      <el-row  :gutter="15">
        <el-col :span="12">
            <el-form-item label="英文名称" prop="nameEn"
                :rules="[
                  {required: true, message:'英文名称不能为空', trigger:'blur'}
                 ]">
              <el-input v-model="inputForm.nameEn" placeholder="请填写英文名称"  maxlength="64"    ></el-input>
           </el-form-item>
        </el-col>
        <el-col :span="12">
            <el-form-item label="中文名称" prop="nameCn"
                :rules="[
                  {required: true, message:'中文名称不能为空', trigger:'blur'}
                 ]">
              <el-input v-model="inputForm.nameCn" placeholder="请填写中文名称"  maxlength="64"    ></el-input>
           </el-form-item>
        </el-col>
        <el-col :span="12">
            <el-form-item label="编码" prop="code"
                :rules="[
                  {required: true, message:'编码不能为空', trigger:'blur'}
                 ]">
              <el-input v-model="inputForm.code" placeholder="请填写编码"  maxlength="64"    ></el-input>
           </el-form-item>
        </el-col>
        <el-col :span="12">
            <el-form-item label="单位" prop="unit"
                :rules="[
                  {required: true, message:'单位不能为空', trigger:'blur'}
                 ]">
              <el-input v-model="inputForm.unit" placeholder="请填写单位"  maxlength="64"    ></el-input>
           </el-form-item>
        </el-col>
        <el-col :span="12">
            <el-form-item label="单价" prop="price"
                :rules="[
                  {required: true, message:'单价不能为空', trigger:'blur'},
                  {validator: validator.isFloatGteZero, trigger:'blur'}
                 ]">
              <el-input v-model="inputForm.price" placeholder="请填写单价"     ></el-input>
           </el-form-item>
        </el-col>
        <el-col :span="24" v-if="method==='edit' || method==='view'">
            <el-form-item label="图片" prop=""
                :rules="[
                 ]">
	            <ImageUploadCustom v-model="inputForm.pic" :multiple="false" :disabled="method==='view'" :otherPrams="otherPrams" action="/unmfile/cecUnmFileupload"  tip="单个图片不要超过10M"></ImageUploadCustom>
           </el-form-item>
        </el-col>
        </el-row>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button size="small" @click="closeDialog">关闭</el-button>
      <el-button size="small" type="primary" v-if="method != 'view'" @click="doSubmit()" v-noMoreClick>确定</el-button>
    </span>
  </el-dialog>
</div>
</template>

<script>
  import cecUnmProjectService from '@/api/unmspace/cecUnmProjectService'
  import ImageUploadCustom from '@/components/upload/ImageUploadCustom'
  export default {
    data () {
      return {
        title: '',
        method: '',
        visible: false,
        loading: false,
        inputForm: {
          id: '',
          nameEn: '',
          nameCn: '',
          code: '',
          unit: '',
          price: '',
          pic: []
        },
        otherPrams: {
          id: '',
          type: 'project'
        }
      }
    },
    components: {
      ImageUploadCustom
    },
    methods: {
      // 关闭弹窗
      closeDialog () {
        this.inputForm.pic = []
        this.visible = false
      },
      // 切换编辑状态
      handEditorView (method) {
        this.method = method === 'view' ? 'edit' : 'view'
      },
      init (method, id) {
        this.method = method
        this.inputForm.id = id
        if (method === 'add') {
          this.title = `新建项目表`
        } else if (method === 'edit') {
          this.title = '修改项目表'
        } else if (method === 'view') {
          this.title = '查看项目表'
        }
        this.visible = true
        this.loading = false
        this.$nextTick(() => {
          this.$refs.inputForm.resetFields()
          if (method === 'edit' || method === 'view') { // 修改或者查看
            this.loading = true
            cecUnmProjectService.queryById(this.inputForm.id).then(({data}) => {
              this.inputForm = this.recover(this.inputForm, data)
              this.otherPrams.id = data.id
              this.inputForm.pic = data.cecUnmFileDTOList
              this.loading = false
            })
          }
        })
      },
      // 表单提交
      doSubmit () {
        this.$refs['inputForm'].validate((valid) => {
          if (valid) {
            this.loading = true
            cecUnmProjectService.save(this.inputForm).then(({data}) => {
              this.visible = false
              this.$message.success(data)
              this.$emit('refreshDataList')
              this.loading = false
            }).catch(() => {
              this.loading = false
            })
          }
        })
      }
    }
  }
</script>
<style scoped>
 ::v-deep .el-dialog__body{
  padding: 10px 20px !important;
}
</style>
  
